import React, { useState } from 'react'
import { Button } from 'components/Button';
import { FormBoxHeading, FormBoxWrapper, FormRightBox, InputFieldStyle, FormSubmitBtn } from '../FormsStyled';
import { FormErrorColor } from '../ModalStyled';
import { useForm, SubmitHandler } from 'react-hook-form';
import FormImage from '../FormImageBox';
import { Link, useHistory, useLocation } from "react-router-dom"
import { Box } from 'components/Box';
import { ReactComponent as BackIcon } from 'assets/Icons/BackIcon.svg';
import axios from 'libs/axios';
import { toast } from 'react-toastify';

const VerifyEmail: React.FC = () => {

    type Inputs = {
        email: string,
        code: string,
    };

    const [open, setOpen] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm<Inputs>();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const { search } = useLocation();
    const urlValues = React.useMemo(() => new URLSearchParams(search), [search]);
    const email = urlValues.get('email');
    const code = urlValues.get('code');

    const onSubmit: SubmitHandler<Inputs> = async data => {
        try {
            setLoading(true);
            const result = await axios.post('/user/verify', data);
            toast.success(result.data.message);
            history.push("/confirmemail");
            setOpen(true);
        } catch (err) {
            //@ts-ignore
            toast.error(err.response.data.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <FormBoxWrapper>

                <FormImage />

                <Box>
                    <Box display={['none', 'none', 'none', 'block']}>
                        <Link to="/">
                            <BackIcon />
                        </Link>
                    </Box>

                    <FormRightBox>
                        <FormBoxHeading>VERIFY YOUR ACCOUNT</FormBoxHeading>

                        <form onSubmit={handleSubmit(onSubmit)}>

                            <InputFieldStyle>
                                <label>Code</label>
                                <input type="text" className="form-control" {...register("code")} readOnly value={code} />
                                <FormErrorColor>{errors.code && errors.code.message}</FormErrorColor>
                            </InputFieldStyle>

                            <InputFieldStyle>
                                <label>Email</label>
                                <input type="email" className="form-control" {...register("email")} readOnly value={email} />
                                <FormErrorColor>{errors.email && errors.email.message}</FormErrorColor>
                            </InputFieldStyle>

                            <FormSubmitBtn>
                                <Button type="submit">Verify</Button>
                            </FormSubmitBtn>

                        </form>
                    </FormRightBox>
                </Box>

            </FormBoxWrapper>

        </>
    )
}

export default VerifyEmail